import React from 'react'

// Source: https://github.com/hampusborgos/country-flags

export function FlagBe({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 39" width={width}>
      <path fill="#ED2939" d="M0 0h45v39H0z"/>
      <path fill="#FAE042" d="M0 0h30v39H0z"/>
      <path d="M0 0h15v39H0z"/>
    </svg>
  )
}

export function FlagDk({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 370 280" width={width}>
      <rect width="370" height="280" fill="#c60c30"/>
      <rect width="40" height="280" x="120" fill="#fff"/>
      <rect width="370" height="40" y="120" fill="#fff"/>
    </svg>
  )
}

export function FlagEe({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 21" width={width}>
      <path fill="#FFF" d="M0 0h33v21H0z"/>
      <path d="M0 0h33v14H0z"/>
      <path fill="#0072CE" d="M0 0h33v7H0z"/>
    </svg>
  )
}

export function FlagFi({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1800 1100" width={width}>
      <rect width="1800" height="1100" fill="#fff"/>
      <rect width="1800" height="300" y="400" fill="#003580"/>
      <rect width="300" height="1100" x="500" fill="#003580"/>
    </svg>
  )
}

export function FlagLt({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3" width={width}>
      <path fill="#BE3A34" d="M0 0h5v3H0z"/>
      <path fill="#046A38" d="M0 0h5v2H0z"/>
      <path fill="#FFB81C" d="M0 0h5v1H0z"/>
    </svg>
  )
}

export function FlagLv({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 3" width={width}>
      <path fill="#9D2235" d="M0 0h6v3H0"/>
      <path fill="#FFF" d="M0 1.2h6v.6H0"/>
    </svg>
  )
}

export function FlagNl({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6" width={width}>
      <path fill="#21468B" d="M0 0h9v6H0z"/><path fill="#FFF" d="M0 0h9v4H0z"/><path fill="#AE1C28" d="M0 0h9v2H0z"/>
    </svg>
  )
}

export function FlagNo({ width = 32 }: { width?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width}>
      <path fill="#ba0c2f" d="M0 0h22v16H0z"/>
      <g fill="#fff">
        <path d="M6 0h4v16H6z"/>
        <path d="M0 6h22v4H0z"/>
      </g>
      <g fill="#00205b">
        <path d="M7 0h2v16H7z"/>
        <path d="M0 7h22v2H0z"/>
      </g>
    </svg>
  )
}
